import { motion } from "framer-motion";
import { SHOW_PLACEHOLDER_BADGES } from "@/lib/site";

export const Reveal = ({ children, delay = 0, y = 24, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Media = ({ img, className = "", imgClassName = "", eager = false, children, testId }) => (
  <div className={`media-frame relative ${img.contain ? "bg-[#050505]" : "bg-silver"} ${className}`} data-testid={testId}>
    <img
      src={img.src}
      alt={img.alt}
      loading={eager ? "eager" : "lazy"}
      className={`h-full w-full ${img.contain ? "object-contain" : "object-cover"} ${imgClassName}`}
    />
    {SHOW_PLACEHOLDER_BADGES && img.placeholder && <span className="placeholder-badge">Placeholder photo</span>}
    {children}
  </div>
);

export const SectionHeading = ({ eyebrow, title, text, light = false, className = "" }) => (
  <Reveal className={`max-w-2xl ${className}`}>
    {eyebrow && <span className="eyebrow">{eyebrow}</span>}
    <h2 className={`heading-lg mt-5 ${light ? "text-white" : "text-ink"}`}>{title}</h2>
    {text && <p className={`mt-5 text-base leading-relaxed md:text-lg ${light ? "text-white/70" : "text-slate-600"}`}>{text}</p>}
  </Reveal>
);

export const PageHero = ({ eyebrow, title, text, img, children }) => (
  <section className="container-x pt-28 md:pt-36">
    <div className="grid items-end gap-10 lg:grid-cols-12">
      <Reveal className="lg:col-span-6">
        <span className="eyebrow">{eyebrow}</span>
        <h1 className="heading-xl mt-6 text-ink">{title}</h1>
        <p className="lead mt-6 max-w-xl">{text}</p>
        {children && <div className="mt-8 flex flex-wrap gap-3">{children}</div>}
      </Reveal>
      <Reveal delay={0.15} className="lg:col-span-6">
        <Media img={img} eager className="aspect-[4/3] lg:aspect-[5/4]" testId="page-hero-image" />
      </Reveal>
    </div>
  </section>
);
